arrayPrefixGenerators